import { useCallback } from 'react';
import { onlyDateToServer, useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import PATHS from '@/common/paths';
import { IDependentInfoDto, IDependentInfoDtoCreationSourceTypeEnum, IDependentResponseDto } from '@/dtos';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';
import { formatDependentSsnToServer } from '@/utils';

export type CreatePatientDto = Partial<Pick<IDependentInfoDto, 'first_name' | 'last_name' | 'birth_on' | 'ssn' | 'relationship_type'>>;
export type CreatedPatientDto = Pick<IDependentResponseDto, 'dependent_id' | 'first_name' | 'last_name'>;

const useCreatePatientQuery = () => {
  const { employee } = useEmployeeStore();

  const { mutateAsync } = useMutation((patientDto: CreatePatientDto) =>
    api.post<CreatedPatientDto>(`${PATHS.CREATE_DEPENDENT}?update_card_holder=false`, {
      ...formatDependentSsnToServer(patientDto.ssn),
      first_name: patientDto.first_name,
      last_name: patientDto.last_name,
      birth_on: onlyDateToServer(patientDto.birth_on),
      person: {
        id: employee?.personId,
        preferred_name: employee?.preferredName,
        first_name: employee?.firstName,
        last_name: employee?.lastName,
      },
      employee_id: employee?.id,
      relationship_type: patientDto.relationship_type,
      creation_source_type: IDependentInfoDtoCreationSourceTypeEnum.WEB_PARTICIPANT_PORTAL,
    })
  );

  const createPatient = useCallback(async (patientDto: CreatePatientDto): Promise<CreatedPatientDto> => {
    const response = await mutateAsync(patientDto);
    return response.data;
  }, [mutateAsync]);

  return {
    createPatient,
  };
};

export default useCreatePatientQuery;
